import { Box, Link } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";

import FailureIcon from "components/datablocks/icons/FailureIcon";
import LoadingIcon from "components/datablocks/icons/LoadingIcon";
import SuccessIcon from "components/datablocks/icons/SuccessIcon";

interface LinkProps {
    link: string;
    linkClick: Dispatch<SetStateAction<boolean>>;
    manualSign: boolean;
}

interface Props {
    children?: React.ReactNode;
    type: string;
    title: string;
    text: string;
    date: string;
    state: 'Pending' | 'Success' | 'Failed';
    midBorderBottom?: boolean;
    midBorderTop?: boolean;
    linkProps?: LinkProps;
}

const DataBlock = (props: Props) => {
    const { 
        children,
        type, 
        title, 
        text, 
        date, 
        state, 
        midBorderBottom = false, 
        midBorderTop = false, 
        linkProps
    } = props;

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "start",
                fontSize: "13px",
                borderRadius:
                    type == "top"
                        ? "10px 10px 0px 0px"
                        : type == "mid"
                            ? "0px"
                            : "0px 0px 10px 10px",
                padding: "20px",
                pr: "35px",
                overflow: "hidden",
                border: `1px solid #bcbcbc`,
                borderTop: type == "mid" && !midBorderTop ? "none" : "1px solid #bcbcbc",
                borderBottom: type == "mid" && !midBorderBottom ? "none" : "1px solid #bcbcbc",
            }}
        >
            {state === "Pending" ? (
                <LoadingIcon />
            ) :
                state === "Success" ? (
                    <SuccessIcon />
                ) : (
                    <FailureIcon />
                )}
            <Box sx={{ width: "100%", mr: "10px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box
                        sx={{
                            alignSelf: "flex-start",
                            fontWeight: "bold",
                            fontSize: "14px",
                            mb: "5px",
                        }}
                    >
                        {title}
                    </Box>
                </Box>

                <Box
                    sx={{
                        flexGrow: "4",
                        textAlign: "justify",
                        whiteSpace: "pre-line",
                        color: "darkgrey",
                    }}
                >
                    {text} <span />
                    {linkProps && (
                        <Link style={{cursor: 'pointer'}} onClick={() => linkProps.linkClick(true)}>{linkProps.link}</Link>
                    )}
                </Box>
                <Box>
                    {children}
                </Box>
            </Box>
            {/* <Box sx={{ fontWeight: "bold", fontSize: "12px" }}>{date}</Box> */}
        </Box>
    );
};
export default DataBlock;
